import { Header } from '@cimpress-technology/pim-header';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth, createAuthorizationCodeGrant } from '../auth.tsx';
import { useSnackbar } from './snackbarProvider.tsx';
import { putSubscriptionUser } from '../services/subscriptions.ts';
import './shell.css';

const authorizationCodeGrant = createAuthorizationCodeGrant('/dashboard');
const { VITE_SHOW_NOTIFICATIONS, VITE_NOTIFICATIONS_ENVIRONMENT } = import.meta.env;

const Shell = ({ children }) => {
  const { setShowSnackbar, setSnackbarMessage } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();

  const putUserData = async () => {
    const { authorizationCode, redirectUri } = await authorizationCodeGrant.handleAuthentication({
      performRedirect: false,
    });

    // this values are defined only when authorizationCodeGrant.login() has been triggered
    if ((authorizationCode || redirectUri) && location.pathname === '/dashboard') {
      // hack to sanitize the url, as it got noise from authorizationCodeGrant.login()
      navigate({ pathname: location.pathname, search: '' });
      const principal = auth.getProfile()['https://claims.cimpress.io/canonical_id'];

      await putSubscriptionUser(principal, authorizationCode, redirectUri);
      setShowSnackbar(true);
      setSnackbarMessage(
        `Successfully refreshed token for ${auth.getProfile()['https://claims.cimpress.io/canonical_id']}`,
      );
    }
  };

  useEffect(() => {
    putUserData();
  }, []);

  return (
    <>
      <Header
        title={'Notifications Hub'}
        titleUrl={'/dashboard'}
        accessToken={auth.getAccessToken()}
        profile={auth.getProfile()}
        onLogInClicked={() => auth.login()}
        onLogOutClicked={() => auth.logout('/')}
        isLoggedIn={auth.isLoggedIn()}
        showNotifications={VITE_SHOW_NOTIFICATIONS !== 'false'}
        notificationsEnvironment={VITE_NOTIFICATIONS_ENVIRONMENT === 'stg' ? 'stg' : 'prd'}
      />
      <div className="root-child">{children}</div>
    </>
  );
};

export default Shell;
